export default "__VITE_ASSET__BTbxqbap__"